import { indexItems } from '@/mocks/home';

export default function SectionIndex() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 mx-auto max-w-7xl">
        <div className="text-center mb-10 md:mb-14">
          <p className="text-sm font-medium text-primary-600 mb-2">探索发现</p>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">精彩专题索引</h2>
          <p className="text-foreground-500 text-sm mt-3 max-w-lg mx-auto">精选八大专题合集，从热播大剧到经典佳作，总有一款对你胃口</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4">
          {indexItems.map((item) => {
            const tagBg = item.tagColor === 'primary' ? 'bg-primary-100 text-primary-700' : item.tagColor === 'secondary' ? 'bg-secondary-100 text-secondary-700' : 'bg-accent-100 text-accent-700';
            return (
              <a
                key={item.id}
                href="#carousel"
                onClick={(e) => { e.preventDefault(); document.querySelector('#carousel')?.scrollIntoView({ behavior: 'smooth' }); }}
                className="group bg-background-100 rounded-xl p-4 md:p-5 border border-background-200/60 hover:border-primary-200 hover:bg-background-50 transition-all duration-300 cursor-pointer"
              >
                <div className="flex items-start justify-between mb-3">
                  <div className="w-10 h-10 md:w-11 md:h-11 rounded-lg bg-primary-100 flex items-center justify-center group-hover:bg-primary-200 transition-colors duration-300">
                    <i className={`${item.icon} text-lg md:text-xl text-primary-600`}></i>
                  </div>
                  <span className={`text-xs px-2 py-0.5 rounded-full font-medium whitespace-nowrap ${tagBg}`}>
                    {item.tag}
                  </span>
                </div>
                <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-900 mb-1.5 group-hover:text-primary-600 transition-colors duration-300">{item.title}</h3>
                <p className="text-xs text-foreground-500 line-clamp-2 leading-relaxed">{item.description}</p>
                <div className="flex items-center gap-1.5 mt-3 text-xs text-foreground-400">
                  <i className="ri-movie-line"></i>
                  <span>{item.count} 部影片</span>
                </div>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
}